import {
  Box,
  Container,
  SimpleGrid,
  VStack,
  Heading,
  Text,
  Image,
  useColorModeValue
} from '@chakra-ui/react';

const CompanyInitiatives = ({ initiatives = [] }) => {
  const cardBg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.600', 'gray.300');

  // If no dynamic data is provided, return empty state
  if (!initiatives || initiatives.length === 0) {
    return (
      <Box py={{ base: 8, md: 12, lg: 16 }}>
        <Container maxW="7xl" px={{ base: 4, md: 6, lg: 8 }}>
          <Text textAlign="center" color={textColor} fontSize="lg">
            No company initiatives available at the moment.
          </Text>
        </Container>
      </Box>
    );
  }

  return (
    <Box py={{ base: 8, md: 12, lg: 16 }}>
      <Container maxW="7xl" px={{ base: 4, md: 6, lg: 8 }}>

        {/* Initiatives Grid */}
        <SimpleGrid 
          columns={{ base: 1, lg: 3 }} 
          spacing={{ base: 6, md: 8 }}
          templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }}
        >
          {initiatives.map((initiative, index) => (
            <Box
              key={index}
              bg={cardBg}
              borderRadius="xl"
              overflow="hidden"
              boxShadow="lg"
              transition="all 0.3s ease"
              _hover={{
                transform: "translateY(-4px)",
                boxShadow: "xl"
              }}
              h="full"
            >
              {/* Image Section */}
              <Box position="relative" h={{ base: "200px", md: "250px" }}>
                {initiative.image ? (
                  <Image
                    src={initiative.image}
                    alt={initiative.title}
                    w="full"
                    h="full"
                    objectFit="cover"
                  />
                ) : (
                  <Box
                    w="full"
                    h="full"
                    bg="gray.200"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text color="gray.500">No Image</Text>
                  </Box>
                )}
                <Box
                  position="absolute"
                  bottom="0"
                  left="0"
                  right="0"
                  bg="linear-gradient(transparent, rgba(0,0,0,0.7))"
                  p={4}
                >
                  <Heading 
                    as="h3" 
                    size={{ base: "lg", md: "xl" }}
                    color="white"
                    fontWeight="bold"
                    textShadow="2px 2px 4px rgba(0,0,0,0.5)"
                  >
                    {initiative.title}
                  </Heading>
                </Box>
              </Box>

              {/* Content Section */}
              <VStack align="start" spacing={4} p={{ base: 4, md: 6 }}>
                <Text 
                  fontSize={{ base: "sm", md: "md" }} 
                  color={textColor}
                  lineHeight="tall"
                  textAlign="justify"
                >
                  {initiative.description}
                </Text>
              </VStack>
            </Box>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default CompanyInitiatives;
